import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import BrandDashboardLayout from "../../components/BrandDashboardLayout";
import { Trash2, ArrowRight, BookmarkCheck } from "lucide-react";

export default function Shortlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/brand/shortlist").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => { await api.delete(`/brand/shortlist/${id}`); load(); };

  return (
    <BrandDashboardLayout>
      <div className="p-6 md:p-12">
        <div className="mb-10">
          <div className="label-eyebrow">Saved</div>
          <h1 className="font-heading text-4xl md:text-5xl uppercase tracking-tighter mt-2" data-testid="shortlist-title">Shortlist</h1>
          <p className="text-ink-muted mt-2 text-sm">Athletes you're considering for upcoming campaigns.</p>
        </div>

        {loading ? (
          <div className="surface p-12 text-center text-ink-muted">Loading…</div>
        ) : items.length === 0 ? (
          <div className="surface p-12 text-center">
            <BookmarkCheck className="w-8 h-8 text-volt mx-auto mb-4" />
            <div className="font-heading text-2xl uppercase">No athletes saved yet</div>
            <p className="text-ink-muted text-sm mt-2 mb-6">Browse the directory and save athletes that fit your next campaign.</p>
            <Link to="/app/brand/directory" className="btn-volt inline-flex items-center gap-2 text-sm" data-testid="goto-directory-btn">
              Browse directory <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="shortlist-grid">
            {items.map(a => (
              <div key={a.id} className="surface p-5 group" data-testid={`shortlist-item-${a.athlete_user_id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1 min-w-0">
                    <Link to={`/app/brand/athlete/${a.athlete_user_id}`} className="font-heading text-xl uppercase tracking-tight truncate hover:text-volt">{a.full_name}</Link>
                    <div className="text-xs text-ink-muted mt-1">{a.sport} {a.level && `· ${a.level}`}</div>
                    {a.location && <div className="text-xs text-ink-muted mt-1">{a.location}</div>}
                  </div>
                  <button onClick={() => remove(a.athlete_user_id)} className="text-ink-muted hover:text-[#FF3B30] opacity-0 group-hover:opacity-100 transition" data-testid={`shortlist-remove-${a.athlete_user_id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
                {!a.still_in_directory && (
                  <div className="text-[10px] uppercase tracking-widest text-[#FF3B30] mt-3">Athlete left the directory</div>
                )}
                <Link to={`/app/brand/athlete/${a.athlete_user_id}`} className="text-volt text-xs uppercase tracking-widest mt-4 inline-flex items-center gap-1">
                  Open <ArrowRight className="w-3 h-3" />
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </BrandDashboardLayout>
  );
}
